import { useEffect } from 'react';
import api from 'api/api';
import { useAuth } from 'hooks/useAuth';

const ApiProvider = ({ children }: any) => {
  const { getToken } = useAuth();

  useEffect(() => {
    // Register interceptor
    const interceptRequest = api.interceptors.request.use(async (config) => {
      const token = await getToken(false);

      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      return config;
    });

    // Response intereptor
    const interceptResponse = api.interceptors.response.use(
      (response) => response,
      (error) => {
        // Reject promise if usual error
        if (
          error.response?.status !== 401 ||
          error.response.data?.errors?.[0].code === '004'
        ) {
          return Promise.reject(error);
        }

        /*
         * When response code is 401, try to refresh the token.
         * Eject the interceptor so it doesn't loop in case
         * token refresh causes the 401 response
         */
        api.interceptors.response.eject(interceptResponse);

        return getToken(true)
          .then((token: string) => {
            error.response.config.headers['Authorization'] = 'Bearer ' + token;
            error.response.config.data = {
              ...JSON.parse(error.response?.config?.data || JSON.stringify({})),
            };
            return api.request(error.response.config);
          })
          .catch((error: Error) => {
            /* IR AL LOGIN PONER NAV */
            return Promise.reject(error);
          });
      },
    );

    return () => {
      api.interceptors.request.eject(interceptRequest);
      api.interceptors.response.eject(interceptResponse);
    };
  }, [getToken]);

  return children;
};

export default ApiProvider;
